import { render, staticRenderFns } from "./OtherHelp.vue?vue&type=template&id=6fe355f5&"
import script from "./OtherHelp.vue?vue&type=script&lang=js&"
export * from "./OtherHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports